import React, { useEffect, useState, useContext, createContext } from 'react'
import SideBarLayout2 from '../../layouts/SideBarLayout2'
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import authService from '../../authentication'
import instance from '../../api/client'
import Loader from '../../components/loaders/Loader'
import AppContext from '../../contexts/AppContext';
import ProjectsContext from '../../contexts/ProjectsContext';
import Taskboard from './Taskboard'
import Timeline from './Timeline'
import Projects from './Projects'


export default function WorkArea() {

  const toggleUnSelectedClass = `bg-white hover:bg-teal-600 text-slate-600 rounded-lg text-sm font-semibold hover:text-white py-1 px-2 border border-white hover:border-transparent`
  const toggleSelectedClass = `bg-teal-600 rounded-lg text-sm font-semibold text-white py-1 px-2 border border-transparent`

  const [isMap, setIsMap] = useState(false);
  const [projects, setProjects] = useState(true);
  const [loading, setLoading] = useState(true);
  const [mapBtnClass, setMapBtnClass] = useState(toggleSelectedClass)
  const [listBtnClass, setListBtnClass] = useState(toggleUnSelectedClass)
  const navigate = useNavigate()
  const location = useLocation();
  const { user } = useContext(AppContext)
  const [pages, setpages] = useState({ taskboard: false, projects: true });

  useEffect(() => {
    getProjects()
  }, [])

  const getProjects = async () => {
    setLoading(true)
    try {
      const { data, status } = await instance.get(`/projects/all-projects`, {
        headers: {
          Authorization: `Bearer ${authService.getCurrentUser()}`
        }
      })
      setProjects(data)
    } catch (error) {
      toast.error(`Error: ${error}`, {
        position: toast.POSITION.TOP_CENTER
      });
    }
    setLoading(false)
  }


  return (
    <ProjectsContext.Provider value={{ location, isMap, setIsMap, projects, setProjects, mapBtnClass, setMapBtnClass, listBtnClass, setListBtnClass, toggleUnSelectedClass, toggleSelectedClass }}>
      <SideBarLayout2 title={'Projects'}>
        {loading &&
          <div style={{}} className='absolute flex items-center justify-center'>
            <div className=' flex-1 shadow-lg mx-5 p-5 items-center justify-center opacity-60'>
              <Loader animationName={'worldmap'} height={'100%'} width={'100%'} />
            </div>
          </div>
        }
        {!loading && (
          <>

            <div className='flex flex-col w-full px-2 pt-2 h-[85vh] m-10 mb-0 bg-white shadow-lg'>

              <div className='flex gap-6 pl-10 font-dmsans border-b-2 border-slate-200 p-2'>
                <Link onClick={() => setpages({ taskboard: false, projects: true })} className={` ${pages.projects ? 'border-b-2 border-slate-600' : ''} `}>
                  <button className='flex gap-1 font-dmsans'>
                    <svg className='mt-1' viewBox="0 0 24 24" fill="currentColor" height="1.2em" width="1.2em" >
                      <path d="M18 19H6a3 3 0 01-3-3V8a1 1 0 00-2 0v8a5 5 0 005 5h12a1 1 0 000-2zm-4-8h-4a1 1 0 000 2h4a1 1 0 000-2zm9-1.06a1.31 1.31 0 00-.06-.27v-.09a1.07 1.07 0 00-.19-.28l-6-6a1.07 1.07 0 00-.28-.19h-.09a.88.88 0 00-.33-.11H8a3 3 0 00-3 3v8a3 3 0 003 3h12a3 3 0 003-3v-4-.06zm-6-3.53L19.59 9H18a1 1 0 01-1-1zM21 14a1 1 0 01-1 1H8a1 1 0 01-1-1V6a1 1 0 011-1h7v3a3 3 0 003 3h3zM10 9h2a1 1 0 000-2h-2a1 1 0 000 2z" />
                    </svg>
                    Projects
                  </button>
                </Link>
                {/* <Link onClick={()=> setpages({taskboard: true, projects: false})} className={` ${pages.taskboard? 'border-b-2 border-slate-600': ''} `}>
            <button className='flex gap-1 font-dmsans appearance-none'>
              <svg className='font-semibold mt-1' fill="currentColor" viewBox="0 0 16 16" height="1em" width="1em">
                <path fillRule="evenodd" d="M10.854 7.146a.5.5 0 010 .708l-3 3a.5.5 0 01-.708 0l-1.5-1.5a.5.5 0 11.708-.708L7.5 9.793l2.646-2.647a.5.5 0 01.708 0z"/>
                <path d="M4 1.5H3a2 2 0 00-2 2V14a2 2 0 002 2h10a2 2 0 002-2V3.5a2 2 0 00-2-2h-1v1h1a1 1 0 011 1V14a1 1 0 01-1 1H3a1 1 0 01-1-1V3.5a1 1 0 011-1h1v-1z" />
                <path d="M9.5 1a.5.5 0 01.5.5v1a.5.5 0 01-.5.5h-3a.5.5 0 01-.5-.5v-1a.5.5 0 01.5-.5h3zm-3-1A1.5 1.5 0 005 1.5v1A1.5 1.5 0 006.5 4h3A1.5 1.5 0 0011 2.5v-1A1.5 1.5 0 009.5 0h-3z" />
              </svg>
              TaskBoard
            </button>
          </Link> */}
              </div>

              <div className='h-[100%] overflow-y-scroll'>
                {/* {pages.taskboard && <Taskboard />} */}
                {pages.projects && <Projects />}
              </div>

            </div>
          </>
        )}
      </SideBarLayout2>
    </ProjectsContext.Provider>
  )
}